<script>
    import { onMount, tick } from "svelte";
    import Chart from 'chart.js/auto';
    import Gradient from "../../../services/gradient.js";
    import { createEventDispatcher } from "svelte";
    import { format, locale } from "svelte-i18n";

    export let findings = [];

    const dispatch = createEventDispatcher();

    let canvas;
    let chart;
    let totals = {};
    let tooltips_titles = {};
    let gradientArray;

    if(findings.length > 1){
        gradientArray = new Gradient()
            //.setColorGradient("#B10c52", "#230B0C")
            .setColorGradient("#343a40","#3c8dbc") // opcion 1
            .setMidpoint((findings.length < 5) ? findings.length : 5)
            .getColors();
        ;
        for(let [index, color] of gradientArray.entries()){
            gradientArray[index] = color + "AE";
        }
    }

    onMount(async () => {
        await tick();

        let context  = canvas.getContext('2d');

        let chartData = {
            labels   : [],
            datasets : {
                backgroundColor : gradientArray ? gradientArray : ["#343a40AE","#3c8dbcAE"],
                data: [],
            },
        }


        for (const fnd of findings) {
            let title = "";
            title = $locale == "es" ? (fnd.title_es.length > 25 ? fnd.title_es.substring(0, 25) + "..." : fnd.title_es) : (fnd.title.length > 25 ? fnd.title.substring(0, 25) + "..." : fnd.title);
            chartData.labels.push(title);
            tooltips_titles[title] = $locale == "es" ? fnd.title_es : fnd.title;
            chartData.datasets.data.push(fnd.value);
        }

        chart = new Chart(context, {
            type: 'bar',
            options: {
                barThickness: 50,
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide
                elements: {
                    bar: {
                        inflateAmount: 1,
                        borderWidth: 0,
                        borderRadius: 2
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 1,
                plugins:{
                    legend: {
                        display: false,
                        position: 'bottom',
                        labels: {
                            font: {
                                fontFamily: 'Montserrat',
                                size: 12
                            }
                        }
                    },
                    tooltip:{
                        callbacks: {
                            title: function(tooltipItem) {
                                return tooltips_titles[tooltipItem[0].label];
                            },
                            fontFamily: 'Montserrat'
                        }
                    },
                },
                title: {
                    display: false,
                },
                animation : {
                    animateScale: true,
                    animateRotate: true,
                },
                scales: {
                    y: {
                        beginAtZero : true,
                        min: 0,
                        ticks: {
                            stepSize: 1,
                            font: {
                                family: 'Montserrat'
                            }
                        }
                    },
                    x: {
                        ticks: {
                            font: {
                                family: 'Montserrat',
                            },
                            display: true,
                            //maxRotation: 0,
                            //position: "right",
                        },
                    },
                },
                onHover : (event) => {
                    canvas.style.cursor = "pointer";
                },
                onClick: (event)=> {
                    let id = findings.filter(fnd=>(event.chart.tooltip.title[0] == fnd.title_es) || (event.chart.tooltip.title[0] == fnd.title))[0].id;
                    dispatch("changeLocation", {vulnerability_id: id})
                }
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets],
                borderWidth: 2,
                borderRadius: 5,
                borderSkipped: false,
            },
        });
    });
</script>
<style>
    /*#chart-vuls-by-severity {
        height: 250px !important;
        margin: 0 auto;
        width: 808px;
    }*/
</style>
<canvas bind:this={canvas} id="chart-vuls-by-severity" class:chart-has-no-data="{findings.length < 1}" ></canvas>
